import React from "react";

import { IconButton, makeStyles } from "@material-ui/core";

import { MobileAddButtonProps } from "./types";
import { Plus } from "react-feather";

const useStyles = makeStyles(theme => ({
  button: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: "4px",
    width: "44px",
    height: "44px",

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

const MobileAddButton: React.FC<MobileAddButtonProps> = props => {
  const classes = useStyles();

  return (
    <IconButton {...props} className={classes.button}>
      <Plus />
    </IconButton>
  );
};

export default MobileAddButton;
